import { AccreditedInvestorGateComponent } from ':cbam/components/AccreditedInvestorGate/AccreditedInvestorGateComponent'
import type { AccreditedInvestorGateFields } from ':cbam/components/AccreditedInvestorGate/types'

export { ACCREDITED_INVESTOR_GATE_CONTENT_MODEL_ID } from ':cbam/components/AccreditedInvestorGate/types'

export function AccreditedInvestorGate({
  pdfAsset,
  modalTitle,
  modalDescription,
  confirmButtonLabel,
  denyButtonLabel,
}: AccreditedInvestorGateFields) {
  const rawUrl = pdfAsset?.fields?.file?.url
  const pdfUrl = rawUrl ? `https:${rawUrl}` : undefined
  const pdfTitle = pdfAsset?.fields?.title

  return (
    <AccreditedInvestorGateComponent
      pdfUrl={pdfUrl}
      pdfTitle={pdfTitle}
      modalTitle={modalTitle}
      modalDescription={modalDescription}
      confirmButtonLabel={confirmButtonLabel}
      denyButtonLabel={denyButtonLabel}
    />
  )
}
